<template>
  <Form :model="formItem" :label-width="80">
    <Row>
      <Col span="5">
     <!--  <FormItem label="查询内容">
        <Input v-model="formItem.inputfilename" class="common-width" placeholder="查询内容"></Input>
      </FormItem> -->
<!--       <FormItem label="文号">
        <Input v-model="formItem.inputnumber" class="common-width" placeholder="文号"></Input>
      </FormItem> -->
      </Col>
    </Row>
    <Row>
      <Col span="6">
      <FormItem label="类别">
        <!--   <Select v-model="formItem.industryselected" multiple class="common-width" placeholder="类别">
          <Option v-for="item in industry" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select> -->
        <!--  <Trade class="common-width"></Trade> -->
        <SingleSelect class="common-width" ref="categorySelector" @onClearText="onCategoryClearText" @tag-Select="getCategorySelection"></SingleSelect>
      </FormItem>

<!--       <FormItem label="">
        <Input v-model="formItem.inputothers" class="common-width" placeholder="关键字"></Input>
      </FormItem> -->
      </Col>
    </Row>
    <!-- 注释于2019.08.19,注释原因：所有引擎取消时间查询条件,改为在二次检索结果中输入时间 -->
    <!-- <FormItem label="时间">
      <Row>
        <Col span="10">
        <DatePicker type="daterange" format="yyyy-MM-dd" placement="bottom-end" class="common-width" placeholder="成文/解读时间范围" v-model="formItem.da" @on-change="timeOnChange"></DatePicker>
        </Col>
      </Row>
    </FormItem> -->
    
    <FormItem label="文件效力">
      <SingleSelect class="common-width" :tData="sTreeData2" @onClearText="onForceClearText" @tag-Select="getForceSelection"></SingleSelect>
      <!-- <ButtonGroup>
        <Button v-for="item in formItem.fileforce" :type="item.type" :key="item.key" @click="ButtonGroupSelect(item.id)">{{item.value}}</Button>
      </ButtonGroup> -->
    </FormItem>
    <FormItem>
      <Button type="primary" icon="ios-search" size="default" @click="Submit()">查询</Button>
    </FormItem>
  </Form>
</template>
<script>
import SelectData from '../../../assets/json/selectData.json'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import ForeignTrade from './foreign_trade_category.vue'
import TreeSingleselect from '../../common/tree-single-select.vue'
import treeData2 from '../../../assets/json/select-tree2.json'

export default {
  name: "Foreign_Trade",
  inject: ['expand'],
  data() {
    return {
      formItem: {
        inputfilename: '',
        inputnumber: '',
        inputothers: '',
        categoryselected: [],
        switch: true,
        da: [],
        fileforce: SelectData.fileforce
      },
      industry: SelectData.foreigntaxcategory,
      cList: SelectData.foreigntax,
      model11: [],
      // sTreeData: this.getSelectTreeData(),
      sTreeData2: this.getSelectTreeData2(),
    }
  },
  methods: {
    ButtonGroupSelect(id) {
      var item = this.formItem.fileforce[id];
      item.Selected = !item.Selected;
      if (item.Selected == true) {
        item.type = "primary";
      } else {
        item.type = "default";
      }

    },
    getFormattedDate(date) {
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;
      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      return year + '-' + month + '-' + day;
    },
    timeOnChange() {
      var time = []
      if (this.formItem.da[0] !== "") {
        time[0] = this.getFormattedDate(this.formItem.da[0])
        time[1] = this.getFormattedDate(this.formItem.da[1])
        this.formItem.da=time
      }else{

      }
    },
    Submit() {

      if (this.sliderLength >= 2) {
        this.screenSet(true);
      }
      this.$emit('onTradeSearch', this.formItem)
      //console.log(this.formItem)

    },
    ...mapMutations([
      'screenSet', 'setSliderLength'
    ]),
    getSelectTreeData() {
      return treeData2.trade
    },
    getSelectTreeData2() {
      return treeData2.force
    },
    propDataInit(data, placeholder, searchable) {
      var a = {}
      a.data = data
      a.placeholder = placeholder
      a.searchable = searchable
      return a
    },
    getCategorySelection(node) {
      this.formItem.categoryselected = node
    },
    onCategoryClearText() {
      this.formItem.categoryselected = {}
    },
    getForceSelection(node) {
      this.formItem.fileforce = node
    },
    onForceClearText() {
      this.formItem.fileforce = {}
    },
    bindCategory() {
      let obj = this.propDataInit(this.sta.initData.inOut, "进出口类别", false)
      this.categoryselected = obj
      this.$refs.categorySelector.bindData(obj)
    },
  },
  mounted() {
    this.bindCategory()
  },
  computed: {
    ...mapGetters(['sliderLength', 'sliderScreen', 'inOutData', 'sta'])
  },
  components: {
    'Trade': ForeignTrade,
    'SingleSelect': TreeSingleselect,
  },
  watch: {
    inOutData: function() {
      // let obj=this.propDataInit(this.sta.initData.inOut,"进出口类别",false)
      // this.$refs.categorySelector.bindData(obj)
      this.bindCategory()
    }
  },

}

</script>
<style scoped>
body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.common-width {
  width: 300px;
}

</style>
